<template>
  <List>
    <template v-slot:list-header>
      <nav class="navbar navbar-light bg-light">
        <div class="container-fluid">
          <div class="navbar-brand">Songs</div>

          <div class="nav-item">
            <div v-b-modal="'add-song'" class="btn btn-outline-primary">
              <b-icon-plus></b-icon-plus>
            </div>
          </div>

          <Modal id="add-song">
            <template v-slot:header>
              Add song
            </template>

            <template v-slot:content="{ changed, close }">
              <Editor v-on="{ changed, saved: created(close) }"></Editor>
            </template>
          </Modal>
        </div>
      </nav>
    </template>

    <template v-slot:list-content>
      <b-input-group size="lg" v-hotkey="keymap">
        <b-form-input v-debounce:100="searchInput" type="search" placeholder="Search" ref="search" :autofocus="$route.name === 'songs.index'"></b-form-input>
      </b-input-group>

      <template v-if="search">
        <div v-if="songs && songs.length" class="list-group">
          <KeyNav :keyLevel="1" :size="songs.length" @selected="selectAtIndex">
            <template v-slot:default="{ preselected }">
              <router-link v-for="(song, index) in songs" :key="song.id" class="list-group-item" :class="[{ 'list-group-item-dark': preselected === index }]" active-class="active" :to="{ name: 'song', params: { songId: song.id }}">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">
                    <highlighter :string="song.title" :search="search"></highlighter>
                  </h5>
                  <time-ago :datetime="song.updated_at" tag="small"></time-ago>
                </div>

                <small>Updated <time-ago refresh :datetime="song.updated_at"></time-ago></small>
              </router-link>
            </template>
          </KeyNav>
        </div>

        <Empty v-else header="No songs found"></Empty>
      </template>

      <Empty v-else icon="b-icon-search" content="Search to find songs"></Empty>
    </template>

    <template v-slot:detail>
      <router-view></router-view>
    </template>
  </List>
</template>

<script>
  import gql from 'graphql-tag'

  import Empty from '../components/Empty';
  import List from '../components/List';
  import TimeAgo from 'vue2-timeago'

  import Modal from '../components/Editor';
  import Editor from '../components/editors/Song';

  import KeyNav from '../components/KeyNav'
  import Highlighter from '../components/Highlighter'

  const SEARCH_SONGS = gql`
    query SearchSongs($search: String!) {
      songs: search_songs(args: { search: $search }) {
        id
        title
        body
        updated_at
      }
    }
  `

  export default {
    name: 'songs',

    components: {
      Empty,
      List,
      TimeAgo,
      Modal,
      Editor,
      KeyNav,
      Highlighter
    },

    methods: {
      focusSearch() {
        this.$refs.search.focus();
      },

      searchInput(value) {
        this.search = value
      },

      created(callback) {
        return function(song, { cache }) {
          const data = cache.readQuery({ query: SEARCH_SONGS });
          data.songs.splice(0, 0, song);

          cache.writeQuery({
            query: SEARCH_SONGS,
            data
          })

          callback();
          this.$router.push({ name: 'song', params: { songId: song.id } })
        }.bind(this)
      },

      selectAtIndex(index) {
        const song = this.songs[index];
        this.$router.push({ name: 'song', params: { songId: song.id } })
      }
    },

    computed: {
      keymap() {
        return {
          '/': this.focusSearch
        }
      }
    },

    data() {
      return {
        search: ''
      }
    },
    
    apollo: {
      songs: {
        query: SEARCH_SONGS,
        
        skip() {
          return !this.search;
        },

        variables() {
          return {
            search: this.search ? `%${this.search}%` : ''
          }
        }
      }
    }
  }
</script>

<style scoped>
  .list-group .btn:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>